/**
 * Configure video component
 */
function modalPopupOpen(modalClass, sliderComponent, value, variant='') {
  let focusBack;
  const modal = document.querySelector(modalClass);
  const stickTo = document.getElementById('stick-to');
  const headerSticky = stickTo.querySelector('.header-sticky');
  const bodyContainer = stickTo.querySelector('.body_container');
  const componentFooter = stickTo.querySelector('.component_footer');
  const modalVariant = document.querySelector('#component_modal');
  const loggedIn = document.body.classList.value;
  if (modal) {
    modal?.setAttribute('aria-hidden', 'false');
    headerSticky?.setAttribute('aria-hidden', 'true');
    bodyContainer?.setAttribute('aria-hidden', 'true');
    componentFooter?.setAttribute('aria-hidden', 'true');
    if(loggedIn.includes('isLoggedIn')){
      modalVariant && modalVariant.classList.add('promotion_wrapper')
    }
    focusBack = document.activeElement;
    modal.classList.add('show');
    const richTextSection = modal.querySelector('.rich_text');
    if(variant){
      modalVariant.classList.add(variant);
    }
    if (richTextSection && value) {
      richTextSection.innerHTML = `<p>${value}</p>`;
    }
    const closeButtonPopUp = modal.querySelector('.close') || modal.querySelector('.close-icon') || modal.querySelector('#reorder-modal-close');
    closeButtonPopUp && closeButtonPopUp.focus();
    function FocusModal(event) {
      if (!modal.contains(event.target)) {
        closeButtonPopUp && closeButtonPopUp.focus();
        event.preventDefault();
      }
    }
    document.addEventListener('focusin', FocusModal);
    if (window.innerWidth <= 1024) {
      document.body.style.overflow = 'hidden';
    }
    if (sliderComponent) {
      sliderComponent.autoplay.stop();
    }

    const handleRemoveAttribute = () => {
      headerSticky?.removeAttribute('aria-hidden');
      bodyContainer?.removeAttribute('aria-hidden');
      componentFooter?.removeAttribute('aria-hidden');
      modal?.setAttribute('aria-hidden', 'true');
      if(variant) {
        modalVariant.classList.remove(variant);
      }
      focusBack.focus();
    };

    const closeHandler = () => {
      modal.classList.remove('show');
      if (modal.classList.contains('reordermodal-overlay')) {
        analytics.emptyVirtualName();
      }
      handleRemoveAttribute();
      if (window.innerWidth <= 1024) {
        document.body.style.overflow = '';
      }
      if (sliderComponent) {
        sliderComponent.autoplay.start();
      }
    };

    const windowClose = event => {
      if (event.target == modal) {
        modal.classList.remove('show');
        handleRemoveAttribute();
        if (window.innerWidth <= 1024) {
          document.body.style.overflow = '';
        }
        if (sliderComponent) {
          sliderComponent.autoplay.start();
        }
      }
    };

    modal.addEventListener('keydown', event => {
      const focusableElements = modal.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      );
      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];

      if (event.key === 'Tab') {
        if (event.shiftKey && document.activeElement === firstFocusable) {
          event.preventDefault();
          lastFocusable.focus();
        } else if (!event.shiftKey && document.activeElement === lastFocusable) {
          event.preventDefault();
          firstFocusable.focus();
        }
      }
    });

    closeButtonPopUp && closeButtonPopUp.addEventListener('click', closeHandler);
    modal.addEventListener('click', windowClose);
  }
}

export { modalPopupOpen };
